import clone from 'clone';
import * as React from 'react';
import { LanguageCode, SurveySegment, SurveySegmentation } from '../../../../amorg-common';
import { Button } from '../../../../designSystem/button/Button';
import { ButtonRow } from '../../../../designSystem/button/ButtonRow';
import { Flex } from '../../../../designSystem/compositeComponents/FlexHelpers';
import { SelectField } from '../../../../designSystem/formField/SelectField';
import { P } from '../../../../designSystem/typography/Body';
import { H2 } from '../../../../designSystem/typography/Heading';
import { SurveyTxt } from '../../../../SurveyTxt';
import { SegmentationProgressPanel } from './ProgressPanel';
import { SurveyOuterCard } from './SurveyCard';

type SetSegmentsProps = {
    txt:SurveyTxt,
    selectedLanguage:LanguageCode,
    segmentations:SurveySegmentation[],
    questionCount: number;
    defaultLanguage:LanguageCode,
    isCompleted:boolean,
    onSubmitSegments: (segments:SurveySegment[]) => void,
    onPreviousClicked: () => void
}
type State = {
    selections: SurveySegment[]
}
export function SetSegments(props: SetSegmentsProps): JSX.Element {

    const [state, setState] = React.useState<State>({
        selections: props.segmentations.map(c => { return { name: c.name, value: '' } })
    });

    function handleSegmentChange(name: string, value: string) {
        let selections = clone(state.selections);
        selections = selections.filter(s => s.name !== name);
        selections.push({ name: name, value });
        setState({ ...state, selections });
    }

    async function handleSubmitSegments() {
        props.onSubmitSegments(state.selections);
    }

    function getSegmentationNameText(ss:SurveySegmentation):string
    {
        if(props.selectedLanguage === props.defaultLanguage)
            return ss.name;
        else
            return ss.translations.find(t => t.languageCode === props.selectedLanguage)?.name || '';
    }

    function getSegmentationValueText(ss:SurveySegmentation, index:number):string
    {
        if(props.selectedLanguage === props.defaultLanguage)
            return ss.values[index];
        else
            return ss.translations.find(t => t.languageCode === props.selectedLanguage)?.values[index] || '';
    }

    return (
        <Flex flexDirection="column">

            <SegmentationProgressPanel
                questionCount={props.questionCount}
                txt={props.txt}
            />

            <SurveyOuterCard>

                <Flex flexDirection="column" gap={16}>
                    <H2>{props.txt.setSegments_header}</H2>

                    {props.isCompleted &&
                        <P><i>{props.txt.setSegments_overwriteWarning}</i></P>
                    }
                    <P>{props.txt.setSegments_introText}</P>
                    {props.segmentations.map(c => {

                        const options = [{ text:props.txt.setSegments_selectText, value:'' },
                            ...c.values.map((v,i) => new Option(getSegmentationValueText(c,i), v))
                        ]

                        return (
                            <SelectField key={c.name}
                                id={`selector-${c.name}`}
                                label={getSegmentationNameText(c)}
                                selectedValue={state.selections.find(s => s.name === c.name)?.value || ''}
                                onChange={(newValue) => { handleSegmentChange(c.name, newValue) }}
                                options={options}
                            />
                        );
                    })}
                    <ButtonRow marginTop={20}>
                        <Button variant="outlined"
                            onClick={props.onPreviousClicked}
                            text={props.txt.setSegments_buttonPreviousText} />
                        <Button variant="filled" 
                            onClick={handleSubmitSegments} 
                            text={props.txt.setSegments_buttonNextText}
                            disabled={state.selections.find(s => s.value === '') !== undefined} />
                    </ButtonRow>
                    
                </Flex>
            </SurveyOuterCard>
        </Flex>
    );
}


